
import { TrendingUp, Target, Settings, CheckCircle, Sparkles } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const KeyFeatures = () => {
  const features = [
    {
      icon: TrendingUp,
      title: "Finance",
      description: "Make sense of your finances",
      details: [
        "Bookkeeping",
        "Invoice Payment Management", 
        "Financial Reporting"
      ]
    },
    {
      icon: Target,
      title: "Strategy", 
      description: "Chart a path to your goals",
      details: [
        "Industry Benchmarking",
        "Pricing & Procurement",
        "Customer Insights"
      ]
    },
    {
      icon: Settings,
      title: "Admin",
      description: "Make more time for what matters",
      details: [
        "Scheduling & Staffing",
        "Permitting & Licensing", 
        "Regulatory Compliance"
      ]
    }
  ];

  return (
    <section className="container mx-auto px-4 py-16 relative z-10">
      <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {features.map((feature, index) => (
          <Card key={index} className="relative overflow-hidden border-0 shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-4 bg-gradient-to-br from-white via-blue-50/50 to-indigo-50/30 group">
            <CardContent className="p-8">
              <div className="flex items-center justify-center w-20 h-20 bg-gradient-to-br from-blue-100 to-indigo-100 rounded-full mb-6 mx-auto border-4 border-blue-200/50 shadow-lg group-hover:scale-110 transition-transform duration-300">
                <feature.icon className="h-8 w-8 text-blue-600" />
              </div>
              <h3 className="text-2xl font-bold text-slate-800 mb-4 text-center group-hover:text-blue-700 transition-colors duration-300">
                {feature.title}
              </h3>
              <p className="text-slate-600 mb-6 text-center font-medium">
                {feature.description}
              </p>
              <ul className="space-y-3">
                {feature.details.map((detail, detailIndex) => (
                  <li key={detailIndex} className="flex items-start gap-3 text-sm text-slate-600 opacity-100 animate-fade-in" style={{animationDelay: `${detailIndex * 0.1}s`, animationFillMode: 'forwards'}}>
                    <CheckCircle className="h-4 w-4 text-blue-500 mt-0.5 flex-shrink-0" />
                    <span>{detail}</span>
                  </li>
                ))}
              </ul>
            </CardContent>
            <div className="absolute -bottom-4 -right-4 w-16 h-16 bg-gradient-to-br from-blue-100 to-transparent rounded-full opacity-30 group-hover:opacity-60 transition-opacity duration-300"></div>
            <div className="absolute top-4 right-4">
              <Sparkles className="h-4 w-4 text-blue-300 opacity-0 group-hover:opacity-100 animate-pulse transition-opacity duration-300" />
            </div>
          </Card>
        ))}
      </div>
    </section>
  );
};

export default KeyFeatures;
